<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";
    import ScrollBar from "./ScrollBar.vue";
    import throttle from "lodash.throttle";

    @Component({
        components: {
            ScrollBar,
        },
    })
    export default class ScrollView extends Vue {
        thumbSizeX = "";
        thumbSizeY = "";

        get scrollView() {
            return this.$refs.scrollView as HTMLElement;
        }
        get scrollBar() {
            return this.$refs.scrollBar as HTMLElement;
        }
        canScrollX = false;
        canScrollY = false;
        update() {
            const view = this.scrollView;

            if (view) {
                let width = (view.clientWidth * 100) / view.scrollWidth;
                let height = (view.clientHeight * 100) / view.scrollHeight;
                this.thumbSizeX = width < 100 ? `${width}%` : "";
                this.thumbSizeY = height < 100 ? `${height}%` : "";
                this.canScrollX = view.scrollWidth != view.clientWidth;
                this.canScrollY = view.scrollHeight != view.clientHeight;
            }
        }

        moveX = 0;
        moveY = 0;
        doScroll() {
            const view = this.scrollView;

            if (view) {
                this.moveX = (view.scrollLeft * 100) / view.clientWidth;
                this.moveY = (view.scrollTop * 100) / view.clientHeight;
            }
        }
        setScrollX(data: number, smooth = false) {
            const view = this.scrollView;
            if (view) {
                if (smooth) {
                    view.scrollTo({
                        left: data,
                        behavior: "smooth",
                    });
                } else {
                    view.scrollLeft = data;
                }
                this.moveX = (view.scrollLeft * 100) / view.clientWidth;
            }
        }
        setScrollY(data: number, smooth = false) {
            const view = this.scrollView;
            if (view) {
                if (smooth) {
                    view.scrollTo({
                        top: data,
                        behavior: "smooth",
                    });
                } else {
                    view.scrollTop = data;
                }
                this.moveY = (view.scrollTop * 100) / view.clientHeight;
            }
        }
        addResize() {
            // todo：节流优化
            window.addEventListener("resize", this.update);
        }
        removeResize() {
            window.removeEventListener("resize", this.update);
        }
        addObserver() {
            if (this.scrollView && this.scrollView.children.length > 0) {
                let scrollDom = this.scrollView.children[0];
                const handleFunc = throttle(() => {
                    if (this.scrollView.scrollHeight != this.scrollView.clientHeight) {
                        this.update();
                    } else {
                        this.canScrollY = false;
                    }
                }, 34);
                new ResizeObserver(handleFunc).observe(scrollDom);
            }
        }
        mounted() {
            this.$nextTick(() => {
                this.update();
                this.addObserver();
            });
            this.addResize();
        }
        beforeDestroy() {
            this.removeResize();
        }
    }
</script>

<template>
    <div ref="scrollBar" class="xx-scrollbar">
        <div ref="scrollView" class="xx-scrollbar-view" @scroll="doScroll">
            <slot />
        </div>
        <ScrollBar v-if="thumbSizeX" :canScroll="canScrollX" :move="moveX" :size="thumbSizeX" @setScroll="setScrollX" />
        <ScrollBar v-if="thumbSizeY" :canScroll="canScrollY" :vertical="true" :move="moveY" :size="thumbSizeY" @setScroll="setScrollY" />
    </div>
</template>

<style lang="stylus" scoped>
    .xx-scrollbar
        height 100%
        overflow hidden
        position relative
        .xx-scrollbar-view
            overflow auto
            height 100%
            scrollbar-width none
            &::-webkit-scrollbar
                display none
</style>
